var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import window from 'window-or-global';

var FloatingMenu = function (_React$Component) {
  _inherits(FloatingMenu, _React$Component);

  function FloatingMenu() {
    _classCallCheck(this, FloatingMenu);

    var _this = _possibleConstructorReturn(this, (FloatingMenu.__proto__ || Object.getPrototypeOf(FloatingMenu)).call(this));

    _this.onNewMenuRef = function (menu) {
      if (!menu) {
        return;
      }
      var doc = menu.ownerDocument;
      if (typeof ReactDOM.createPortal === 'function') {
        _this.setState({ doc: doc });
        if (menu.firstChild) {
          _this.menu = menu;
          _this.getMenuPosition();
        }
      } else {
        _this.menu = doc.createElement('div');
        doc.body.appendChild(_this.menu);

        var style = {
          display: 'block',
          opacity: 0
        };
        var childrenWithProps = React.cloneElement(_this.props.children, {
          style: style
        });
        ReactDOM.render(childrenWithProps, _this.menu);

        _this.getMenuPosition();
        _this.renderLayer();
      }
    };

    _this.getMenuPosition = function () {
      var _this$menu$firstChild = _this.menu.firstChild.getBoundingClientRect(),
          menuWidth = _this$menu$firstChild.width,
          menuHeight = _this$menu$firstChild.height;

      _this.menuWidth = menuWidth;
      _this.menuHeight = menuHeight;
    };

    _this.positionFloatingMenu = function () {
      var menuOffset = _this.props.menuOffset;

      var scroll = window.scrollY || 0;

      var _this$props$menuPosit = _this.props.menuPosition,
          refLeft = _this$props$menuPosit.left,
          refTop = _this$props$menuPosit.top,
          refRight = _this$props$menuPosit.right,
          refBottom = _this$props$menuPosit.bottom;


      var refCenterHorizontal = (refLeft + refRight) / 2;
      var refCenterVertical = (refTop + refBottom) / 2;

      return {
        left: function left() {
          return {
            left: refLeft - _this.menuWidth - menuOffset.left,
            top: refCenterVertical - _this.menuHeight / 2 + scroll + menuOffset.top
          };
        },
        top: function top() {
          return {
            left: refCenterHorizontal - _this.menuWidth / 2 + menuOffset.left,
            top: refTop - _this.menuHeight + scroll - menuOffset.top
          };
        },
        right: function right() {
          return {
            left: refRight + menuOffset.left,
            top: refCenterVertical - _this.menuHeight / 2 + scroll + menuOffset.top
          };
        },
        bottom: function bottom() {
          return {
            left: refCenterHorizontal - _this.menuWidth / 2 + menuOffset.left,
            top: refBottom + scroll + menuOffset.top
          };
        }
      }[_this.props.menuDirection]();
    };

    _this.getChildrenWithProps = function () {
      var transientStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var pos = _this.state.floatingPosition || _this.positionFloatingMenu();

      var coreStyles = {
        left: pos.left + 'px',
        top: pos.top + 'px',
        position: 'absolute',
        right: 'auto',
        margin: 0,
        opacity: 1
      };

      var style = _extends(coreStyles, _this.props.styles, transientStyles);
      return React.cloneElement(_this.props.children, {
        style: style
      });
    };

    _this.renderLayer = function () {
      ReactDOM.render(_this.getChildrenWithProps(), _this.menu);
    };

    _this.state = {};
    return _this;
  }

  _createClass(FloatingMenu, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (typeof ReactDOM.createPortal !== 'function') {
        this.renderLayer();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var _this2 = this;

      if (typeof ReactDOM.createPortal === 'function') {
        var hasChange = props.menuPosition !== this.props.menuPosition || props.menuDirection !== this.props.menuDirection || props.menuOffset !== this.props.menuOffset;
        if (hasChange) {
          requestAnimationFrame(function () {
            if (_this2.menuWidth !== undefined && _this2.menuHeight !== undefined) {
              _this2.setState({ floatingPosition: _this2.positionFloatingMenu() });
            }
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof ReactDOM.createPortal !== 'function') {
        ReactDOM.unmountComponentAtNode(this.menu);
        if (this.menu && this.menu.parentNode) {
          this.menu.parentNode.removeChild(this.menu);
        }
      }
      this.menuWidth = undefined;
      this.menuHeight = undefined;
      this.menu = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.doc && typeof ReactDOM.createPortal === 'function') {
        var childrenWithProps = this.getChildrenWithProps(this.menuWidth !== undefined && this.menuHeight !== undefined ? {} : {
          display: 'block',
          opacity: 1
        });
        return ReactDOM.createPortal(React.createElement(
          'div',
          { ref: this.onNewMenuRef },
          childrenWithProps
        ), // Add wrapper `<div>` to align to React15 version
        this.state.doc.body);
      }

      return React.createElement('div', { ref: this.onNewMenuRef, hidden: true });
    }
  }]);

  return FloatingMenu;
}(React.Component);

FloatingMenu.propTypes = {
  children: PropTypes.any,
  menuPosition: PropTypes.object.isRequired,
  menuDirection: PropTypes.oneOf(['left', 'top', 'right', 'bottom']).isRequired,
  menuOffset: PropTypes.object.isRequired,
  styles: PropTypes.object
};
FloatingMenu.defaultProps = {
  menuPosition: { left: 0, top: 0, right: 0, bottom: 0 },
  menuDirection: 'bottom'
};


export default FloatingMenu;


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/internal/FloatingMenu.js
// module id = 117
// module chunks = 0